import {
  REQUIRED_EMAIL_VALIDATOR,
  REQUIRED_PHONE_NUMBER_VALIDATOR,
  REQUIRED_TEXT_FIELD_VALIDATOR,
  TEXT_FIELD_VALIDATOR,
} from '@/helpers/formHelpers/validators';
import { ORG_ADMIN_ROLE } from '@/const/user';
import { object } from 'yup';

export const CREATE_ADMIN_INITIAL_VALUES = {
  role: ORG_ADMIN_ROLE.ORG_ADMIN,
  email: '',
  mobile_phone: '',
  first_name: '',
  middle_name: '',
  last_name: '',
};

export const CREATE_ADMIN_VALIDATION_SCHEMA = object().shape({
  role: REQUIRED_TEXT_FIELD_VALIDATOR,
  email: REQUIRED_EMAIL_VALIDATOR,
  mobile_phone: REQUIRED_PHONE_NUMBER_VALIDATOR,
  first_name: REQUIRED_TEXT_FIELD_VALIDATOR,
  middle_name: TEXT_FIELD_VALIDATOR,
  last_name: REQUIRED_TEXT_FIELD_VALIDATOR,
});

export const EDIT_ORGANIZATION_DETAILS_VALIDATION_SCHEMA = object().shape({
  name: REQUIRED_TEXT_FIELD_VALIDATOR,
});
